import { useEffect, useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import classNames from 'classnames';
import { t } from 'ttag';

import ClothIcon from '@svg/cloth.svg';
import { sendSimilarProductsViewEvent } from '@utils/analytics';
import { Button } from '@ui/Button';

import s from './ProductDetailsSimilarProductsLink.sss';

const SIMILAR_PRODUCT_SECTION_ID = 'similar-products';
const ANIMATION_DELAY = 2500; //ms

interface Props {
  className?: string,
}

export const ProductDetailsSimilarProductsLink: React.FC<Props> = ({
  className,
}) => {
  const [isIconType, setIsIconType] = useState(false);

  const handleClick = () => {
    sendSimilarProductsViewEvent();

    document
      ?.querySelector(`#${SIMILAR_PRODUCT_SECTION_ID}`)
      ?.scrollIntoView({ behavior: 'smooth', block: 'start' });

  };

  useEffect(() => {
    const timer = setTimeout(() => setIsIconType(true), ANIMATION_DELAY);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Button
      className={classNames(s.button, className, {
        [s.buttonTypeIcon]: isIconType,
      })}
      onClick={handleClick}
    >
      <ClothIcon
        className={s.icon}
        width="24"
        height="24"
      />
      <CSSTransition
        in={!isIconType}
        timeout={200}
        classNames={{
          appear: s.appear,
          appearActive: s.appearActive,
          enter: s.enter,
          enterActive: s.enterActive,
          exit: s.exit,
          exitActive: s.exitActive,
        }}
        unmountOnExit={true}
      >
        <span className={s.text}>
          {t`Схожі товари`}
        </span>
      </CSSTransition>
    </Button>
  );
};
